import { ApiPaths } from 'services/api/apiPaths';
import { createResourceApi } from '../../createResourceApi';

export const parametersApi = createResourceApi(ApiPaths.PARAMETERS, (rest) => ({
  getAll: () => rest.get<SystemParamsResponse>()
}));
